import './App.css';
import { BrowserRouter as Router, useRoutes, Routes, Route, Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { IntlProvider } from 'react-intl';
import { CookiesProvider } from 'react-cookie';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_OAUTH_CLIENT_ID, GOOGLE_OAUTH_CLIENT_SECRET } from "./constants";

import _404Page from './components/404Page';
import ProtectedRoute from './pages/Auth/ProtectedRoute';
import Login from './pages/Auth/Login';
import Admin from './pages/Admin';

import Layout from './components/Layout';
import Home from './pages/Home';

const customTheme = extendTheme({
  fonts: {
      heading: 'Helvetica Neue, sans-serif',
      body: 'Quicksand'
  }
});

function App() {
  return (
    <CookiesProvider>
      <ChakraProvider theme={customTheme}>
        <IntlProvider locale='vi'>
          <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
            <Router>
              <Routes>
                  <Route element={<ProtectedRoute />}>
                    <Route path='/' element={<Layout />}>
                      <Route index element={<Home />}/>
                      <Route path='/compare-money' element={<Home />} />
                      {/* <Route path='/import-datas' element={<Home />} /> */}
                      <Route path='/import-datas-v2' element={<Home />} />
                      <Route path='/import-datas-v2' element={<Home />} />
                      <Route path='/order-management' element={<Home />} />
                      <Route path='/admin' element={<Home />} />
                    </Route>
                  </Route>
                  <Route path='/login' element={<Login />} />
                  <Route path='/notfound' element={<_404Page />} />
                <Route path='/*' element={<_404Page />} />
              </Routes>
            </Router>
          </GoogleOAuthProvider>
        </IntlProvider>
      </ChakraProvider>
    </CookiesProvider>
  );
}

export default App;